import React, { useState } from 'react';
import { useEffect } from 'react';
import moment from 'moment';

import ScheduleList from '../partials/components/scheduleList';
import { useRootContext } from '../partials/context/rootContext';

import ReactGA from 'react-ga4';

const Breakouts = ({ ...props }) => {
    const { dataContext, setDataContext, scheduleContext, setScheduleContext } = useRootContext();
    let localRooms;
    const [rooms, setLocalRooms] = useState(localRooms);

    useEffect(() => {
        if (dataContext.rooms) {
            let updatedRooms = [...dataContext.rooms];
            updatedRooms = updatedRooms.map(item => {
                item.buttonText = 'Select';
                item.buttonDisabledText = 'Remove';
                item.buttonToggleText = 'Remove';
                item.buttonToggled = item.registered;
                item.description =  item.description; //'' //overwrite description to hide it
                //  item.buttonDisabled = item.registered || false;
                //  item.hidden = item.registered;

                return item;
            });
            const sortedRooms = updatedRooms.filter((item) => { return !item.auto_register && item.room_type.value == 'breakout'}).sort(
                (a, b) => moment(a.start).format('YYYYMMDDHHMM') - moment(b.start).format('YYYYMMDDHHMM')
            );

            setLocalRooms(sortedRooms);
        }
    }, [dataContext.rooms]);

    const updateRooms = newRooms => {
        setDataContext({
            ...dataContext,
            rooms: newRooms
        });
    };

    useEffect(() => {}, [scheduleContext]);

    const onReserveSessionClick = (i, session) => {
        if (session.registered) {
            unreserveSession(i, session);
        } else {
            reserveSession(i, session);
        }
    };

    const updateRoom = (i, toUpdate) => {
        let updatedRooms = [...dataContext.rooms];

        Object.keys(toUpdate).map(function (key) {
            for (let j in updatedRooms) {
                if (updatedRooms[j].unique == i) {
                    updatedRooms[j][key] = toUpdate[key];
                }
            }
        });

        updateRooms(updatedRooms);
    };

    const reserveSession = (i, session) => {
        updateRoom(i, { busy: true });

        fetch(
            launchframe.ajax_url +
                '?action=register_for_room&wp_id=' +
                dataContext.current_event +
                '&room_id=' +
                session.unique,
            {
                method: 'POST'
            }
        )
            .then(res => res.json())
            .then(
                result => {
                    ReactGA.event({
                        category: "Breakouts",
                        action: "Register",
                        label: session.title + ' | ' + session.start, // optional
                        nonInteraction: false // optional, true/false
                    });
                    updateRoom(session.unique, { busy: false, registered: true });
                    let newSchedule = [];
                    if (scheduleContext) {
                        newSchedule = scheduleContext;
                    }
                    newSchedule.push(session);
                    setScheduleContext(newSchedule);
                },

                error => {
                    updateRoom(i, { busy: false });
                }
            );
    };

    const unreserveSession = (i, session) => {
        updateRoom(i, { busy: true });

        fetch(
            launchframe.ajax_url +
                '?action=unregister_for_room&wp_id=' +
                dataContext.current_event +
                '&room_id=' +
                session.unique,
            {
                method: 'POST'
            }
        )
            .then(res => res.json())
            .then(
                result => {
                    ReactGA.event({
                        category: "Breakouts",
                        action: "Unregister",
                        label: session.title + ' | ' + session.start, // optional
                        nonInteraction: false // optional, true/false
                    });
                    updateRoom(session.unique, { busy: false, registered: false });
                    let newSchedule = [];
                    if (scheduleContext) {
                        newSchedule = scheduleContext;
                    }
                    newSchedule.push(session);
                    setScheduleContext(newSchedule);
                },

                error => {
                    updateRoom(i, { busy: false });
                }
            );
    };

    return (
        <div className="px-4 py-8 lg:py20 font-sans container">
            <ScheduleList className="px-4 space-y-4" items={rooms} onButtonClick={onReserveSessionClick} />
        </div>
    );
};

export default Breakouts;
